import CaretRight from './CaretRight'

export default CaretRight
// eslint-disable-next-line import/export
export * from './CaretRight'
